import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f131e2ba&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f131e2ba&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f131e2ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f131e2ba')) {
      api.createRecord('f131e2ba', component.options)
    } else {
      api.reload('f131e2ba', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f131e2ba&scoped=true", function () {
      api.rerender('f131e2ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/limitBox/index.vue"
export default component.exports